import { useState } from 'react';
import client from '../api/client';

export default function PinResetModal({ onClose }) {
  const [step, setStep] = useState('request');
  const [adminId, setAdminId] = useState('');
  const [otp, setOtp] = useState('');
  const [newPin, setNewPin] = useState('');
  const [newPin2, setNewPin2] = useState('');
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const request = async () => {
    if (loading) return;
    setLoading(true); setErr('');
    try {
      const email = localStorage.getItem('admin_email');
      if (!email) { setErr('Email not found. Sign out and sign in again.'); return; }
      const r = await client.post('/admin/auth/reset-pin/request', { email });
      setAdminId(r.data.adminId); setStep('confirm'); setMsg('OTP sent to your email');
    } catch (e) { setErr(e.response?.data || 'Failed'); } finally { setLoading(false); }
  };

  const confirm = async () => {
    setErr('');
    if (newPin !== newPin2) return setErr('PINs do not match');
    if (newPin.length < 4) return setErr('PIN must be at least 4 digits');
    setLoading(true);
    try {
      await client.post('/admin/auth/reset-pin/confirm', { adminId, otp, newPin });
      setMsg('PIN updated');
      setTimeout(onClose, 1500);
    } catch (e) { setErr(e.response?.data || 'Failed'); } finally { setLoading(false); }
  };

  const inp = { width:'100%', padding:'10px 12px', background:'#fff', border:'1px solid #ddd', borderRadius:7, color:'#111', fontSize:14, outline:'none', marginBottom:10, boxSizing:'border-box' };
  const primary = { flex:1, padding:'9px', background:'#1a5cff', color:'#fff', border:'none', borderRadius:6, cursor:'pointer', fontWeight:600, fontSize:14 };
  const secondary = { flex:1, padding:'9px', background:'#f1f1f1', color:'#555', border:'none', borderRadius:6, cursor:'pointer', fontSize:14 };

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:2000 }}>
      <div style={{ background:'#fff', borderRadius:12, padding:28, width:340, border:'1px solid #eee' }}>
        <h3 style={{ color:'#111', margin:'0 0 16px', fontSize:16 }}>Reset my PIN</h3>
        {err && <div style={{ background:'#fff5f5', border:'1px solid #f0c0c0', borderRadius:7, padding:'8px 12px', color:'#a32d2d', fontSize:13, marginBottom:12 }}>{String(err)}</div>}
        {msg && <div style={{ background:'#f0fff6', border:'1px solid #b2dfdb', borderRadius:7, padding:'8px 12px', color:'#0a8a40', fontSize:13, marginBottom:12 }}>{msg}</div>}
        {step === 'request' ? (
          <>
            <div style={{ color:'#555', fontSize:14, marginBottom:14 }}>An OTP will be sent to your email to verify your identity.</div>
            <div style={{ display:'flex', gap:8 }}>
              <button style={primary} onClick={request} disabled={loading}>{loading?'Sending...':'Send OTP'}</button>
              <button style={secondary} onClick={onClose}>Cancel</button>
            </div>
          </>
        ) : (
          <>
            <input style={inp} placeholder="Enter OTP from email" value={otp} onChange={e=>setOtp(e.target.value)} />
            <input style={inp} type="password" placeholder="New PIN (4-8 digits)" value={newPin} onChange={e=>setNewPin(e.target.value)} maxLength={8} />
            <input style={inp} type="password" placeholder="Confirm new PIN" value={newPin2} onChange={e=>setNewPin2(e.target.value)} maxLength={8} />
            <div style={{ display:'flex', gap:8 }}>
              <button style={{...primary, opacity:loading?0.7:1}} onClick={confirm} disabled={loading}>{loading?'Saving...':'Set new PIN'}</button>
              <button style={secondary} onClick={onClose}>Cancel</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
